var api = require("!../../../../../node_modules/@umijs/deps/compiled/style-loader/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../node_modules/@umijs/deps/compiled/css-loader/cjs.js??ruleSet[1].rules[9].oneOf[0].use[1]!../../../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[9].oneOf[0].use[2]!../../../../../node_modules/@umijs/deps/compiled/less-loader/cjs.js??ruleSet[1].rules[9].oneOf[0].use[3]!./index.less?modules");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"base":0};

options.insert = "head";
options.singleton = false;

var update = api(content, options);


if (module.hot) {
  if (!content.locals || module.hot.invalidate) {
    var isEqualLocals = function isEqualLocals(e,n,f){if(!e&&n||e&&!n){return false}var s;for(s in e){if(f&&s==="default"){continue}if(e[s]!==n[s]){return false}}for(s in n){if(f&&s==="default"){continue}if(!e[s]){return false}}return true};
    var oldLocals = content.locals;

    module.hot.accept(
      "!!../../../../../node_modules/@umijs/deps/compiled/css-loader/cjs.js??ruleSet[1].rules[9].oneOf[0].use[1]!../../../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[9].oneOf[0].use[2]!../../../../../node_modules/@umijs/deps/compiled/less-loader/cjs.js??ruleSet[1].rules[9].oneOf[0].use[3]!./index.less?modules",
      function () {
        content = require("!!../../../../../node_modules/@umijs/deps/compiled/css-loader/cjs.js??ruleSet[1].rules[9].oneOf[0].use[1]!../../../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[9].oneOf[0].use[2]!../../../../../node_modules/@umijs/deps/compiled/less-loader/cjs.js??ruleSet[1].rules[9].oneOf[0].use[3]!./index.less?modules");

              content = content.__esModule ? content.default : content;

              if (typeof content === 'string') {
                content = [[module.id, content, '']];
              }

              if (!isEqualLocals(oldLocals, content.locals)) {
                module.hot.invalidate();

                return;
              }

              oldLocals = content.locals;

              update(content);
      }
    )
  }

  module.hot.dispose(function() {
    update();
  });
}

module.exports = content.locals || {};